exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drive-folder-wrapper[data-v-fe08286c]{position:relative}.drive-folder-wrapper:focus .btn-item-remove[data-v-fe08286c],.drive-folder-wrapper:hover .btn-item-remove[data-v-fe08286c]{display:block}.drive-folder-wrapper .btn-item-remove[data-v-fe08286c]{position:absolute;display:none;top:-16px;left:-10px;color:#dc3545}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fe08286c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/projects/Reports.vue
// module id = rWqk
// module chunks = 0